module.exports = __webpack_public_path__ + "static/media/group-member-select.cd9af4bf.svg";